// Formatage des nombres à la française, identique dans toute l'app.
// Intl sépare les milliers par une espace fine (U+202F), presque invisible à l'écran :
// on la remplace par une espace insécable normale, bien lisible (« 51 513 », « 8 440 768 € »).

const THIN_SPACES = new RegExp(`[${String.fromCharCode(0x202F, 0x2009)}]`, 'g')

const NBSP = String.fromCharCode(0xA0)

const readable = (text) => text.replace(THIN_SPACES, NBSP)

export function formatNumber(value, options = {}) {
    return readable(Number(value || 0).toLocaleString('fr-FR', options))
}

export function formatCurrency(value, currency = 'EUR', options = {}) {
    return readable(Number(value || 0).toLocaleString('fr-FR', { style: 'currency', currency, ...options }))
}

// « 27,3 % » ; « — » quand il n'y a pas de valeur
export function formatPercent(value, options = {}) {
    if (value === null || value === undefined || value === '') {
        return '—'
    }

    return `${formatNumber(value, options)}${NBSP}%`
}
